import { ClientApi, ToastStateHandler } from '../../../api';
import { dispatch } from '../../../store';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { useOrganizationId } from '../../state';
import { setClients } from '../../../store/slices/clients.slice';
import { useTranslation } from '../../useTranslation';
import { useClients } from '../../state/useClients';

const useHttpGetAllClientsOnMount = () => {
    const { t } = useTranslation('newNotifications');
    const organizationId = useOrganizationId();
    const clientApi: ClientApi = useContainer(ClientApi);
    const [isReady, setReady] = useState<boolean>(false);
    const toastHandler = useContainer(ToastStateHandler);
    const cachedClients = useClients();

    useEffect(() => {
        if (!organizationId) return;

        if (cachedClients.length > 0) {
            setReady(true);
            return;
        }

        const { exec, abort } = clientApi.getAll({
            params: { organizationId },
            onSuccess: res => dispatch(setClients(res.body)),
            onError: _ => toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setReady(true),
        });
        exec();
        return abort;
    }, [clientApi, organizationId, cachedClients.length]);

    return { isReady };
};

export default useHttpGetAllClientsOnMount;
